import { types, Image } from "react-bricks/frontend";
import styled from "styled-components";
import { color } from "styles/colours";
import { backgroundColorProp } from "../utils/backgroundColor";

export interface LogoWallImageProps {
  maxWidth: number;
}

const LogoWallImage: types.Brick<LogoWallImageProps> = ({ maxWidth }) => {
  return (
    <Image
      propName="logoImage"
      alt="logoImage"
      maxWidth={maxWidth}
      renderWrapper={({ children }) => (
        <ImageWrapper width={`${maxWidth}px`}>{children}</ImageWrapper>
      )}
      placeholder={() => "/static/logos/BupaLogo.png"}
    />
  );
};

LogoWallImage.schema = {
  name: "logo-wall-image",
  label: "Logo Wall Image",
  category: "Logo Wall",
  hideFromAddMenu: true,
  repeaterItems: [],
  getDefaultProps: () => ({
    maxWidth: 188,
  }),
  sideEditProps: [],
};

const ImageWrapper = styled.div<{ width?: string }>`
  max-width: ${(p) => (p.width ? `${p.width}` : "auto")};
  img {
    max-width: 100%;
    height: auto;
  }
`;

export default LogoWallImage;
